const positive=value=>Number.isFinite(Number(value))&&Number(value)>0?Number(value):null;
const sum=values=>values.reduce((a,b)=>a+b,0);
export const percentage=value=>value==null?'Not available':`${value.toFixed(1)}%`;
export function placementCounts(group) {
  const counts={};for(const page of group?.sheets||[])for(const p of page.placements||[])counts[p.line_id]=(counts[p.line_id]||0)+1;
  return counts;
}
const countKey=group=>JSON.stringify(Object.entries(placementCounts(group)).sort(([a],[b])=>a.localeCompare(b)));
export function profileAreas(lines=[]) {
  const areas={};for(const line of lines) {
    const geometry=line.geometry||{};
    if(geometry.areaVerification?.state==='verified'||geometry.areaMeasurement==='closed_cut_contours') {
      const area=positive(geometry.areaSqm);if(area)areas[line.id]=area*1e6;
    }
  }
  return areas;
}
export function cadProfileAreas(group) {
  const areas={};for(const page of group?.sheets||[])for(const p of page.placements||[]) {
    const area=positive(p.net_area_mm2);if(area)areas[p.line_id]=area;
  }
  return areas;
}
function areaFor(placements,areas) {
  if(!placements.length||placements.some(p=>!positive(areas[p.line_id])))return null;
  return sum(placements.map(p=>areas[p.line_id]));
}
function utilisation(area,stockArea) {
  return positive(stockArea)&&area!=null&&area>=0&&area<=stockArea+0.001?100*area/stockArea:null;
}
export function usageMetrics(group,{sheet=group?.sheet||{},areas={},profileNetArea=null,sheetIndex=0,rectangle=false}={}) {
  const pages=group?.sheets||[],width=positive(group?.sheet_length_mm??sheet.length_mm),height=positive(group?.sheet_width_mm??sheet.width_mm);
  const count=pages.length,stockArea=width&&height&&count?width*height*count:null;
  const all=pages.flatMap(page=>page.placements||[]),selected=pages[Math.min(Math.max(0,sheetIndex??0),Math.max(0,count-1))]?.placements||[];
  const netArea=positive(profileNetArea)??areaFor(all,areas),netPct=utilisation(netArea,stockArea);
  const selectedArea=areaFor(selected,areas),selectedPct=utilisation(selectedArea,width&&height?width*height:null);
  const rectangleArea=rectangle&&all.length&&all.every(p=>positive(p.width_mm)&&positive(p.height_mm))?sum(all.map(p=>p.width_mm*p.height_mm)):null;
  const price=Number.isSafeInteger(sheet.price_cents)&&sheet.price_cents>=0?sheet.price_cents:null;
  return {sheetCount:count,partCount:all.length,lengthMm:width,widthMm:height,purchasedAreaMm2:stockArea,netAreaMm2:netArea,
    netUtilisationPct:netPct,wastePct:netPct==null?null:100-netPct,selectedNetUtilisationPct:selectedPct,selectedWastePct:selectedPct==null?null:100-selectedPct,
    selectedPartCount:selected.length,rectangleFootprintPct:utilisation(rectangleArea,stockArea),materialCostCents:price==null||!count?null:price*count};
}
export function quickSourceSheet(nest,lines) {
  const ids=new Set(Object.keys(placementCounts(nest)));
  const sources=lines.filter(line=>ids.has(line.id)).map(line=>line.price_audit?.source_snapshot?.sheet).filter(Boolean);
  if(!sources.length||sources.some(sheet=>sheet.id!==sources[0].id))return {};
  return sources[0];
}
export function quickUsage(nest,lines,index=0,reference={}) {
  return usageMetrics(nest,{sheet:quickSourceSheet(nest,lines),areas:{...profileAreas(lines),...(nest.validated?cadProfileAreas(nest):{}),...(reference.areas||{})},profileNetArea:reference.netArea??(nest.validated?positive(nest.net_part_area_mm2):null),sheetIndex:index,rectangle:true});
}
export function cadUsage(group,index=0) {
  return usageMetrics(group,{areas:cadProfileAreas(group),profileNetArea:positive(group?.net_part_area_mm2),sheetIndex:index});
}
export function savedQuickGroups(quote) {
  const lines=quote.price_snapshot?.priced_lines||quote.lines||[],seen=new Set(),groups=[];
  for(const line of lines) {
    const recovery=line.price_audit?.source_snapshot?.material_recovery,layout=recovery?.quick_nest;
    if(!layout?.sheets?.length)continue;
    const sheet=line.price_audit?.source_snapshot?.sheet||{},key=sheet.id+'|'+countKey(layout);
    if(seen.has(key))continue;seen.add(key);groups.push({layout,sheet,lines,recoveryMode:recovery.mode});
  }
  return groups;
}
export function compareNestGroup(quote,cad) {
  if(!cad)return null;
  const quick=savedQuickGroups(quote).find(item=>countKey(item.layout)===countKey(cad));if(!quick)return null;
  const materialMatches=['family_name','grade_name','thickness_mm'].every(key=>quick.sheet[key]!=null&&cad.sheet?.[key]!=null&&String(quick.sheet[key])===String(cad.sheet[key]));
  const sameSpacing=Number(quick.layout.clearance_mm)===Number(cad.clearance_mm)&&Number(quick.layout.edge_margin_mm)===Number(cad.edge_margin_mm);
  const cadMetrics=cadUsage(cad),reference=materialMatches?{areas:cadProfileAreas(cad),netArea:cadMetrics.netAreaMm2}:{};
  const quickMetrics=quickUsage(quick.layout,quick.lines,0,reference);
  return {quick:quickMetrics,cad:cadMetrics,comparable:materialMatches&&sameSpacing&&!quote.snapshot_is_stale,recoveryMode:quick.recoveryMode,
    reason:quote.snapshot_is_stale?'The saved Quick estimate uses older quote inputs. Reprice before comparing.':!materialMatches?'Material groups differ; these results cannot be ranked together.':!sameSpacing?'Spacing or margin differs; these results use different constraints.':null};
}
export function weightedUsage(metrics) {
  if(!metrics.length||metrics.some(value=>value.netAreaMm2==null||!positive(value.purchasedAreaMm2)))return null;
  return utilisation(sum(metrics.map(value=>value.netAreaMm2)),sum(metrics.map(value=>value.purchasedAreaMm2)));
}
